<div v-bind:class="useClassName">
  <button type="button" 
      class="btn btn-primary matrix_uploadButtonDelete"             
      v-if="showDeleteButton"
      @click="uploadOnDelete(propsData.code)">
    {{$t('Delete')}}
  </button>
  <button
    type="button"
    class="btn btn-primary matrix_uploadButtonPreview"
    @click="uploadOnPreview(propsData.code)"
    v-if="getShowPreviewInUpload && getAttribute('previewFile')"
  >
    {{$t('Preview')}}
  </button>
  <button type="button" class="btn btn-primary matrix_uploadButtonDownload" 
    @click="uploadOnDownload(propsData.code)">
    {{$t('Download')}}
  </button>
  <button
    v-if="getAttribute('showRearrange')"
    type="button"
    class="btn btn-primary matrix_uploadButtonRearrange"
    @click="uploadOnRearrange(propsData.code)"
  >
    {{$t('Rearrange pages')}}
  </button>
  <button
    v-if="getAttribute('pitstopReport')"
    type="button"
    class="btn btn-primary matrix_uploadButtonViewReport"
    @click="uploadOnViewReport(propsData.code)"
  >
    {{$t('View report')}}
  </button>
</div>